import { CostDealType, B2CDealType, B2BDealType } from "@/app/constants";
import { ReactiveComponent } from "../../entities/base-component";
import { Pricing } from "../../entities/pricing";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";

export class EstimateWithExtraCalculationStrategy extends CalculationStrategy {
    calculate = (
        component: ReactiveComponent,
        [estimatePrice, extraTotal],
    ): PriceResult => {
        return {
            price: this.calculatePriceForType(
                estimatePrice, extraTotal,
                CostDealType,
            ),
            priceB2C: this.calculatePriceForType(
                estimatePrice, extraTotal,
                B2CDealType,
            ),
            priceB2B: this.calculatePriceForType(
                estimatePrice, extraTotal,
                B2BDealType,
            ),
        };
    };

    private calculatePriceForType(
        estimatePrice: Pricing,
        extraTotal: Pricing,
        dealType: string,
    ): number {
        const estimatePriceValue = estimatePrice?.getSystemPrice(dealType).getValue() || 0;
        const extraTotalValue = extraTotal?.getSystemPrice(dealType).getValue() || 0;

        return estimatePriceValue + extraTotalValue;
    }
}
